export const EVENT_ASSIGNMENTS_TABLE_MODE = {
  TEAM_TABLE: 0,
  ATL_RANKING: 1,
  ATL_PREFERENCES: 2
};
